import { render, staticRenderFns } from "./UserDetailModal.vue?vue&type=template&id=a1122a62&"
import script from "./UserDetailModal.vue?vue&type=script&lang=js&"
export * from "./UserDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports